import {createSliceSelectors} from "../selectors";

export const NAME_SLICE = 'operation'

export interface OperationState {
    starving: {
        data: (string[])[]
        loading: boolean
    }
}

export const initialState: OperationState = {
    starving: {
        data: [],
        loading: false
    },

}

export const selectOperation = createSliceSelectors(NAME_SLICE, initialState);
